export const Show = ({ condition, children }) => {
  return condition ? children : null
}
